/**
 * Generate unique key for FileObject, handling duplicates
 * @param {string} fileHash - The file hash
 * @param {Array} existingFiles - Array of existing FileObjects
 * @returns {string} - Unique key for React component
 */
export const generateUniqueKey = (fileHash, existingFiles) => {
	// Extract existing keys for this hash
	const existingKeys = existingFiles.map(file => file.key);
	
	// If base hash is not used, return it
	if (!existingKeys.includes(fileHash)) {
		return fileHash;
	}
	
	// Find the highest counter for this hash
	let counter = 1;
	while (existingKeys.includes(`${fileHash}_${counter}`)) {
		counter++;
	}
	
	return `${fileHash}_${counter}`;
};
